import { render, staticRenderFns } from "./product-cover-groups.vue?vue&type=template&id=ee8e5598&scoped=true&"
import script from "./product-cover-groups.vue?vue&type=script&lang=js&"
export * from "./product-cover-groups.vue?vue&type=script&lang=js&"
import style0 from "./product-cover-groups.vue?vue&type=style&index=0&id=ee8e5598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8e5598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee8e5598')) {
      api.createRecord('ee8e5598', component.options)
    } else {
      api.reload('ee8e5598', component.options)
    }
    module.hot.accept("./product-cover-groups.vue?vue&type=template&id=ee8e5598&scoped=true&", function () {
      api.rerender('ee8e5598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/product-finishes-slider/components/product-cover-groups.vue"
export default component.exports